// Pure deterministic helpers for CompareScansView (extracted for
// testability). Zero React, zero I/O, zero LLM. All inputs come from
// the /api/opportunities/compare-scans response payload.

export function pluralize(n, singular, plural) {
  return n === 1 ? singular : plural;
}

// Displayed verbatim as the REC COUNT Δ tooltip on the summary strip.
export const RECOUNT_TOOLTIP =
  "Difference in recommendation count between Scan B and Scan A. "
  + "This does not imply upgrades, downgrades, additions, or drops "
  + "because the evaluated universes may differ.";

/**
 * Deterministic "What changed?" sentences generated CLIENT-SIDE from the
 * comparison payload. Zero external calls. Only non-zero categories are
 * surfaced. Evidence-vs-inference wording is strictly enforced.
 */
export function buildWhatChangedSentences(summary) {
  if (!summary) return [];
  const out = [];
  const add = (n, s) => { if (n > 0) out.push(s); };
  add(summary.unchanged,
      `${summary.unchanged} ${pluralize(summary.unchanged,
        "recommendation persisted across both scans and remained unchanged.",
        "recommendations persisted across both scans and remained unchanged.")}`);
  add(summary.upgraded,
      `${summary.upgraded} ${pluralize(summary.upgraded,
        "recommendation was upgraded.",
        "recommendations were upgraded.")}`);
  add(summary.downgraded,
      `${summary.downgraded} ${pluralize(summary.downgraded,
        "recommendation was downgraded.",
        "recommendations were downgraded.")}`);
  add(summary.true_new,
      `${summary.true_new} ${pluralize(summary.true_new,
        "symbol was evaluated in both scans and became a new recommendation.",
        "symbols were evaluated in both scans and became new recommendations.")}`);
  add(summary.true_dropped,
      `${summary.true_dropped} ${pluralize(summary.true_dropped,
        "previously evaluated recommendation was genuinely dropped.",
        "previously evaluated recommendations were genuinely dropped.")}`);
  add(summary.newly_scanned,
      `${summary.newly_scanned} ${pluralize(summary.newly_scanned,
        "symbol was newly evaluated in Scan B and was recommended.",
        "symbols were newly evaluated in Scan B and were recommended.")}`);
  add(summary.not_rescanned,
      `${summary.not_rescanned} Scan A ${pluralize(summary.not_rescanned,
        "recommendation was not re-scanned, so no Scan B verdict change can be inferred for it.",
        "recommendations were not re-scanned, so no Scan B verdict change can be inferred for them.")}`);
  add(summary.new_evaluation_unknown,
      `${summary.new_evaluation_unknown} Scan B ${pluralize(summary.new_evaluation_unknown,
        "recommendation lacks lineage evidence to confirm whether Scan A evaluated it.",
        "recommendations lack lineage evidence to confirm whether Scan A evaluated them.")}`);
  add(summary.status_unknown,
      `${summary.status_unknown} Scan A ${pluralize(summary.status_unknown,
        "recommendation lacks lineage evidence to confirm whether Scan B evaluated it.",
        "recommendations lack lineage evidence to confirm whether Scan B evaluated them.")}`);
  return out;
}
